import React, {Component} from 'react';
import {connect} from 'react-redux';
import FilterBySalary from 'components/organisms/filter-by-salary';
import FilterByPoints from 'components/organisms/filter-by-points';
import ExposureMode from 'components/molecules/exposure-mode';
import UniquePlayersQuantity from 'components/molecules/unique-players-quantity';
import LineupsQuantity from 'components/organisms/lineups-quantity';
import SelectSalaryCap from 'components/organisms/select-salary-cap';
// import PlayerNameStack from 'components/organisms/player-name-stacking';
import OptimizeButton from 'components/molecules/optimize-button';
import FilterByOrder from 'components/organisms/filter-by-order';
import FilterByConfirmed from 'components/molecules/filter-by-confirmed';
import PrioritizeCompletingLineupsAboveExp from 'components/molecules/prioritize-completing-lineups-above-exp';
import RangeOfOutcomesByPositions from 'components/organisms/range-of-outcomes/range-of-outcomes-by-positions';
import ProjectionPointsType from 'components/molecules/projection-points-type';
import ShowPlayersExposureWhileOptimized from 'components/molecules/show-players-exposure-while-optimized';
import PlayerCombinationStacking from 'components/organisms/player-combination-stacking';
import OptimizeOpener from 'components/molecules/optimize-opener';
import ProjectedOwnershipCap from 'components/organisms/projected-ownership-cap';
import SinglegameForcedStacking from 'components/organisms/singlegame-forced-stacking';
import PlayerGroupingsSwitch from 'components/molecules/player-groupings-switch';
import PlayerPositionStacking from 'components/organisms/player-position-stacking';
import ProjectionBoostRule from 'components/organisms/projection-boost-rule';

class PlayersDashboardComponent extends Component {
    render() {
        const {sportConfig, playersFilter} = this.props;

        const maxUniquePlayers = sportConfig.getPlayersInTeam() - 1;

        return (
            <div>
                <div className="filters-table">
                    <OptimizeOpener />
                    <div className="filters-top">
                        <div className="filters-top-holder">
                            <FilterBySalary
                                key={`sr-${playersFilter.playersType}`}
                                useDragging={true}
                                mode={playersFilter.playersType}
                            />
                            <FilterByPoints
                                key={`pr-${playersFilter.playersType}`}
                                useDragging={true}
                                mode={playersFilter.playersType}
                            />
                            <SelectSalaryCap useDragging={true} />
                            <ProjectedOwnershipCap useDragging={true} />
                            <LineupsQuantity useDragging={true} />
                        </div>
                        <div className="filters-cell select-cell">
                            <ExposureMode />
                            <ProjectionPointsType
                                options={{
                                    userPoints: 'Fantasy Points',
                                    grades: 'Rating',
                                }}
                            />
                            <UniquePlayersQuantity max={maxUniquePlayers} />
                        </div>
                    </div>
                    <div className="filters-bottom">
                        <div className="filters-cell">
                            <FilterByOrder />
                        </div>
                        <div className="filters-cell">
                            <FilterByConfirmed />
                        </div>
                        <div className="filters-cell">
                            <PrioritizeCompletingLineupsAboveExp />
                        </div>
                        <div className="filters-cell">
                            <RangeOfOutcomesByPositions
                                useDragging={true}
                                positionsGroupName="hitter"
                                config={{sport: 'mlb'}}
                            />
                        </div>
                        <div className="filters-cell">
                            <RangeOfOutcomesByPositions
                                useDragging={true}
                                positionsGroupName="pitcher"
                                config={{sport: 'mlb'}}
                            />
                        </div>
                        <div className="filters-cell">
                            <ShowPlayersExposureWhileOptimized />
                        </div>
                    </div>
                    <OptimizeButton />
                </div>
                <SinglegameForcedStacking />
                {/*<PlayerNameStack/>*/}
                <PlayerPositionStacking />
                <PlayerGroupingsSwitch>
                    <PlayerCombinationStacking />
                    <ProjectionBoostRule />
                </PlayerGroupingsSwitch>
            </div>
        );
    }
}

function mapStatesToProps(state) {
    const {sportConfig} = state;
    const {filters: playersFilter} = state.playersData;

    return {
        sportConfig,
        playersFilter,
    };
}

let PlayersDashboard = connect(mapStatesToProps)(PlayersDashboardComponent);

export {PlayersDashboard};
